<div class="container">
    <div class="row">
        <div class="col-md-12"></div>
    </div>
</div>